// SEO 공용 상수 (프레임워크 무관 — App Router 전환 후에도 그대로 재사용)
/** 사이트 기준 URL. canonical·sitemap 등 절대 URL 생성에 사용. */ export const SITE_URL = process.env.NEXT_PUBLIC_APP_ENDPOINT || "https://solvook.com";
/**
 * sitemap 파일 하나에 담을 URL 수.
 * sitemap 프로토콜 상한은 50,000이지만, Amplify SSR(Lambda) 응답 페이로드 한계(~6MB)에 걸린다.
 * URL당 ~137B라 50,000개면 ~6.5MB로 초과 → 빈 응답이 되므로 여유를 두고 25,000으로 제한.
 * (이 값을 다시 올리려면 배포 환경의 Lambda 응답 크기 한계를 먼저 확인할 것)
 */ export const MAX_URLS_PER_SITEMAP = 25000;
/** 조각 XML 크기 경고 임계치(바이트). 이 값을 넘으면 Lambda 6MB 한계 접근을 경고. */ export const SITEMAP_SIZE_WARN_BYTES = 5 * 1024 * 1024;
/** sitemap 라우트 공용 캐시 정책 — CDN/엣지에서 캐싱해 크롤러 반복 요청 시 BE 부하 완화 */ export const SITEMAP_CACHE_CONTROL = "public, s-maxage=3600, stale-while-revalidate=86400";
